import angular from 'angular';

export const getLimitOptions = () => [5, 10, 25, 50, 100];
export const getQuery = () => angular.copy({
  take: 10,
  page: 1,
  calculateSkip: function calculateSkip() {
    return this.take * (this.page - 1);
  }
});

export const transformODataResponse = r => ({
  Count: r.data['@odata.count'],
  Data: r.data.value
});



// WEBPACK FOOTER //
// ./common/utilities/query.js